<script>
  import axios from 'axios';
  import {mapGetters} from 'vuex';
  import {mapActions} from 'vuex';

  export default {
    name: "",
    props: {
      legal: {
        default: '',
      },
      agreement: {
        default: '',
      },
      payment: {
        default: '',
      },
    },
    data() {
      return {
        loading: false,
        visible: false,
        cashes: [],
        form: {
          OnlineCashId: 0,
          BillProvideTypeId: 1,
        },
        doc: {
          id: 0,
          status: 0,
          provide: 0,
          cash: 0,
        },
        isFeatureBlocked: false
      }
    },
    computed: {
      ...mapGetters({
        permission: 'permission',
      }),
      ...mapGetters('user', {
        hasFeature: 'hasFeature',
      }),
      cash() {
        return this.cashes.find(i=>i.Id===this.doc.cash);
      },
      icon() {
        if (this.loading) return 'el-icon-loading';
        switch (this.doc.status) {
          case 1:
            return 'el-icon-info';
          case 2:
            return 'el-icon-tickets';
          case 3:
            return 'el-icon-refresh';
          default:
            return '';
        }
      },
      title() {
        if (this.loading) return 'Ваш запрос выполняется';
        switch (this.doc.status) {
          case 1:
            return 'Проверить статус чека';
          case 2:
            if(this.cash && !this.cash.Capabilities.CanPrintDocumentCopy) {
              return '';
            }
            return 'Дублировать чек';
          case 3:
            return 'Распечатать чек';
          default:
            return 'Распечатать чек';
        }
      }
    },
    methods: {
      ...mapActions('user', {
        promptNoFeature: 'promptNoFeature',
      }),
      async init() {
        this.clear();
        if (!this.hasFeature([8])){
          console.log('online cashboxes disabled');
          this.isFeatureBlocked = true;
        }
        this.getDocument();
        this.cashes = await this.getList();
        if (this.cashes.length) {
          this.form.OnlineCashId = this.cashes[0].value
        }
      },
      wrapperClick(){
        if (this.isFeatureBlocked){
          this.promptNoFeature('Работа с онлайн кассами недоступна для Вашего тарифного плана. Перейти к управлению тарифами?');
        }
      },
      click() {
        if (this.loading) return;
        this.loading = true;
        switch (this.doc.status) {
          case 1:
            this.getCheck()
              .then(() => {
                this.$emit('status', 2);
                this.loading = false;
              })
              .catch(() => {
                this.$emit('status', 3);
                this.loading = false;
              });
            break;
          case 2:
            this.getCopy()
              .then(() => {
                this.loading = false;
              });
            break;
          case 3:
            this.getCheck()
              .then(() => {
                this.$emit('status', 2);
                this.loading = false;
              })
              .catch(() => {
                this.$emit('status', 3);
                this.loading = false;
              });
            break;
          default:
            this.visible = true;
            this.loading = false;
            return '';
        }
        this.getDocument();
      },
      createCheck() {
        const self = this;
        if (self.loading) return;
        self.loading = true;
        self.visible = false;
        axios
          .post(
            '/tourclient/api/onlinecash/document/process',
            `OnlineCashId=${self.form.OnlineCashId}&PaymentId=${self.payment}&BillProvideTypeId=${self.form.BillProvideTypeId}&DocumentTypeId=1`
          )
          .then(({data}) => {
            this.getStatus(self.form.OnlineCashId, data.CheckOperationId)
              .then(() => {
                self.$notify.success('Успешно распечатан/отправлен чек');
                self.loading = false;
                self.getDocument();
              })
              .catch(err => {
                self.$notify.error(err);
                self.loading = false;
                self.getDocument();
              });
          })
          .catch(err => {
            self.$notify.error('Произошла ошибка');
            self.loading = false;
            self.visible = false;
          });
      },
      getCheck() {
        return new Promise((resolve, reject) => {
          axios
            .post(
              '/tourclient/api/onlinecash/document/process',
              `OnlineCashId=${this.doc.cash}&FiskalDocumentId=${this.doc.id}`
            )
            .then(({data}) => {
              if (data.CheckOperationId) {
                this.getStatus(this.doc.cash, data.CheckOperationId)
                  .then(() => {
                    switch (this.doc.status) {
                      case 1:
                        this.$notify.success('Успешно распечатан/отправлен чек');
                        break;
                      case 2:
                        this.$notify.success('Успешно распечатан/отправлен дубликат');
                        break;
                      case 3:
                        this.$notify.success('Успешно распечатан/отправлен чек');
                        break;
                      default:
                    }
                    resolve();
                  })
                  .catch(err => {
                    this.$notify.error(err);
                    reject();
                  });
              } else {
                switch (data.OperationStatusId) {
                  case 2:
                    this.$notify.success('Успешно распечатан/отправлен дубликат');
                    resolve();
                    break;
                  case 3:
                    this.$notify.error(data.ResultQueryInfo.UserMessages);
                    reject();
                    break;
                }
              }
            })
        });
      },
      getCopy() {
        return new Promise((resolve) => {
          axios
            .post(
              '/tourclient/api/onlinecash/doccopy',
              `cashId=${this.doc.cash}&fiskalDocumentId=${this.doc.id}`
            )
            .then(resolve, resolve);
        });
      },
      getStatus(cash, id) {
        return new Promise((resolve, reject) => {
          axios
            .get(`/tourclient/api/onlinecash/document/${cash}/${id}`)
            .then(({data}) => {
              switch (data.OperationStatusId) {
                case 1:
                  setTimeout(() => {
                    this.getStatus(cash, id).then(resolve, reject);
                  }, 1000);
                  return;
                case 2:
                  resolve();
                  break;
                case 3:
                  reject(data.ResultQueryInfo.UserMessages);
                  break;
              }
            })
            .catch(() => {
              reject('Ошибка в проведении чека');
            });
        });
      },
      getList() {
        return new Promise((resolve) => {
          let data = '';
          if (this.legal) {
            data += `LegalEntityId=${encodeURIComponent(this.legal)}&`;
          }
          if (this.agreement) {
            data += `AgreementCode=${encodeURIComponent(this.agreement)}&`;
          }
          axios
            .get(
              `/tourclient/settings/onlineCashSettingsList?${data}_=${new Date().getTime()}`,
            )
            .then(({data}) => {
              resolve(data.OnlineCashes ? data.OnlineCashes.map(i => ({
                ...i,
                value: i.Id,
                label: `${i.Name} ${i.LegalEntityId ? ('(' + i.LegalEntityName + ')') : ''}`,
              })) : []);
            })
            .catch(() => {
              resolve([]);
            })
        });
      },
      handleClose(done) {
        this.visible = false;
        done();
      },
      getDocument() {
        return new Promise(resolve => {
          axios
            .get(`/tourclient/api/onlinecash/documentslist?paymentId=${this.payment}`)
            .then(({data}) => {
              const check = data.Receipts[0];
              if (check) {
                this.doc.id = check.Id;
                this.doc.status = check.ResultTypeId;
                this.doc.provide = check.BillProvideTypeId;
                this.doc.cash = check.OnlineCashId;
              } else {
                this.clear();
              }
            })
        })
      },
      clear() {
        this.doc.id = 0;
        this.doc.status = 0;
        this.doc.provide = 0;
        this.doc.cash = 0;
      }
    },
    watch: {
      legal() {
        this.init();
      },
      agreement() {
        this.init();
      },
      payment() {
        this.clear();
      },
    },
    components: {},
    mounted() {
      this.init();
    },
    destroyed() {
    },
  }
</script>
<template>
  <div style="display: inline-block;" @click="wrapperClick" v-if="title">
    <el-button
      @click="click"
      :disabled="loading || isFeatureBlocked"
      type="primary"
      class="online-cashes-button-certificate"
      v-if="cashes.length&&payment&&permission(283)"
    >
      {{title}}
      <el-dialog
        :visible="visible"
        width="400px"
        append-to-body
        title="Онлайн касса"
        :before-close="handleClose"
      >
        <div v-loading="loading">
          <OnlineCashesForm
            :cashes="cashes"
            :form="form"
          >
          </OnlineCashesForm>
          <div style="text-align: right">
            <el-button @click="visible=false">Отмена</el-button>
            <el-button type="primary" @click="createCheck">Отправить</el-button>
          </div>
        </div>
      </el-dialog>
    </el-button>
  </div>
</template>
<style lang="scss">
  .online-cashes-button-table.el-button {
    padding: 4px 8px;
    font-size: 16px;
    margin-top: 1px;
  }
</style>
